/** Forces every link inside HTML content to open in a new tab. */
export function addTargetBlankToLinks(html: string): string
{
  if (!html || typeof document === 'undefined') return html;

  const container = document.createElement('div');
  container.innerHTML = html;

  container.querySelectorAll('a[href]').forEach(anchor =>
  {
    const href = anchor.getAttribute('href') || '';

    // mailto:/tel: open the mail/phone app, not a page - a new tab makes no sense
    if (/^(mailto|tel):/i.test(href)) return;

    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  });

  return container.innerHTML;
}
